(function ($, document, window) {
	'use strict';

	function checkIfCardCarouselNavNeed(sliderWrapper, sliderElement, nav) {
		const slidesWidth = sliderWrapper.scrollWidth;
		const sliderWidth = sliderElement.offsetWidth;

		if (slidesWidth <= sliderWidth) {
			nav.addClass('carousel-nav--hidden');
		} else {
			nav.removeClass('carousel-nav--hidden');
		}
	}

	$(function () {
		$('.js-featured-card-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const sliderWrapper = $('.js-featured-card-carousel-wrapper', sliderContainer)[0];
			const navParent = $('.js-featured-card-carousel-nav', sliderContainer);

			// https://codepen.io/ABCDEFGHIJ/pen/KKKrddp
			let swiper;
			const breakpoint = window.matchMedia('(min-width:80em)'); // keep track of swiper instances to destroy later
			const breakpointChecker = function breakpointChecker() {
				// if larger viewport and multi-row layout needed
				if (breakpoint.matches === true) {
					// clean up old instances and inline styles when available
					if (swiper !== undefined) swiper.destroy(true, true);
					$('.carousel-nav', sliderContainer).hide();

					return; // else if a small viewport and single column layout needed
				} else if (breakpoint.matches === false) {
					// fire small viewport version of swiper
					$('.carousel-nav', sliderContainer).show();
					return enableSwiper();
				}
			};

			const enableSwiper = function enableSwiper() {
				swiper = new Swiper(sliderEl, {
					direction: 'horizontal',
					slidesPerView: 1.4,
					breakpoints: {
						570: {
							slidesPerView: 2.4,
						},
						767: {
							slidesPerView: 3.15,
						},
						1400: {
							slidesPerView: 4,
						},
						1600: {
							slidesPerView: 5,
						}
					},

					navigation: {
						nextEl: $('.js-carousel-nav-next', sliderContainer)[0],
						prevEl: $('.js-carousel-nav-prev', sliderContainer)[0],
					},

					on: {
						resize: function() {
							checkIfCardCarouselNavNeed(sliderWrapper, sliderEl, navParent)
						},
						init: function() {
							checkIfCardCarouselNavNeed(sliderWrapper, sliderEl, navParent)
						},
					}
				});
			};

			$(function () {
				if (sliderContainer.data('size') === 'small') {
					breakpoint.addListener(breakpointChecker); // kickstart
					breakpointChecker();
				} else {
					enableSwiper();
				}
			});
		});
	});
})(jQuery, document, window);
